// src/pages/HowItWorksPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'; // Import motion

const HowItWorksPage = () => {

    // Define motion variants for the card hover/interaction
    // NOTE: whileHover handles the mouse events, but to combine it with
    // whileHover defined inside the variants object, we need to pass a property, 
    // or simply use the existing CSS classes which Framer Motion will animate.
    // For this code, we'll keep the motion-specific hover variant.
    const cardHover = {
        rest: { scale: 1, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' },
        hover: { 
            scale: 1.03, 
            boxShadow: '0 10px 20px rgba(100, 149, 237, 0.4)',
            transition: { duration: 0.3 } 
        }
    };
    
    // Define motion variants for the staggered grid entrance
    const container = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15, // Stagger children animations
            }
        }
    };

    const item = {
        hidden: { y: 20, opacity: 0 },
        visible: { y: 0, opacity: 1 }
    };

    // Use motion.div for the card component and add motion props
    const StepCard = ({ number, title, content }) => (
        <motion.div 
            className="how-it-works-card"
            variants={item} // Apply item entrance animation
            initial="hidden"
            animate="visible"
            whileHover={{ scale: 1.03, boxShadow: '0 10px 20px rgba(100, 149, 237, 0.4)' }} // Apply hover effect directly
            transition={{ duration: 0.4 }}
        >
            <div className="how-it-works-number-ring">
                <span className="how-it-works-number">{number}</span>
            </div>
            <h3 className="how-it-works-card-title">{title}</h3>
            <p className="how-it-works-description">{content}</p>
        </motion.div>
    );

    return (
        <div className="public-page-container">
            <h1 className="public-page-title">How NYC Connect Works</h1>
            <p className="public-page-subtitle">Our process is simple: Local. Verified. Connected.</p>
            
            {/* Wrap the grid in the motion container */}
            <motion.div 
                className="page-content-block how-it-works-grid" 
                style={{ maxWidth: '1000px' }}
                variants={container}
                initial="hidden"
                animate="visible"
            >
                
                <StepCard
                    number={1}
                    title="Verify Your Location"
                    content="Quickly verify your NYC residence (Borough and neighborhood) to ensure local relevance."
                />
                <StepCard
                    number={2}
                    title="Join Local Chats"
                    content="Gain instant access to real-time chat rooms dedicated exclusively to your verified area."
                />
                <StepCard
                    number={3}
                    title="Stay Informed"
                    content="Receive crucial local alerts, participate in discussions, and find neighborhood events."
                />
            </motion.div>
            
            <motion.div 
                className="how-it-works-faq-link-container"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.8 }}
            >
                <h2 className="how-it-works-faq-text" style={{ margin: '0 0 10px 0' }}>Still have questions?</h2>
                
                <Link to="/about-faq" className="how-it-works-faq-button">
                    Visit Our FAQ
                </Link>
            </motion.div>
        </div>
    );
};

export default HowItWorksPage;